const AccountCircle = () => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z'
        fill='#402080'
      />
      <path
        d='M16.0018 29.0081C22.2247 29.0081 27.2693 26.0962 27.2693 22.5041C27.2693 18.912 22.2247 16 16.0018 16C9.77898 16 4.73438 18.912 4.73438 22.5041C4.73438 26.0962 9.77898 29.0081 16.0018 29.0081Z'
        fill='#EDEFF1'
      />
      <path
        d='M15.9963 16.0003C19.5883 16.0003 22.5003 13.0883 22.5003 9.49625C22.5003 5.90416 19.5883 2.99219 15.9963 2.99219C12.4042 2.99219 9.49219 5.90416 9.49219 9.49625C9.49219 13.0883 12.4042 16.0003 15.9963 16.0003Z'
        fill='#EDEFF1'
      />
      <path
        d='M15.9997 23.8049L21.2494 17.1032C19.6437 16.394 17.8678 16 15.9997 16C14.1316 16 12.3557 16.394 10.75 17.1032L15.9997 23.8049Z'
        fill='#D3D3D3'
      />
    </svg>
  )
}

export default AccountCircle
